<template>
    <div>
        <div
            class="af-attributes-group-container afu-flex afu-flex-wrap afu-flex-col md:afu-flex-row md:afu-items-center afu-bg-white afu-pt-4 afu-pb-2"
            :class="{'afu-border afu-border-solid afu-border-neutral afu-px-4 afu-rounded-card': withBorder}"
        >
            <span>
                <input
                    type="checkbox"
                    :name="name"
                    :id="id"
                    v-model="localValue"
                    v-on="inputListeners"
                >
            </span>
            <span
                class="afu-pl-2"
                v-html="content"
            />
        </div>
        <C1HelpText
            v-if="invalidFeedback"
            variant="danger"
        >
            {{ invalidFeedback }}
        </C1HelpText>
    </div>
</template>

<script>
    import C1HelpText from './C1HelpText';

    export default {
        name: 'C1CheckBox',

        components: { C1HelpText },

        data() {
            return {
                localValue: this.value,
            };
        },

        props: {
            value: {
                type: [Boolean],
                default: false,
            },

            id: {
                type: String,
                default: undefined,
            },

            name: {
                type: String,
                default: '',
            },

            content: {
                type: String,
                default: '',
            },

            withBorder: {
                type: [Boolean],
                default: true,
            },

            isInvalid: {
                type: Boolean,
                default: false,
            },

            invalidFeedback: {
                type: [String, Boolean],
                default: false,
            },
        },

        computed: {
            inputListeners() {
                const vm = this;
                return {
                    ...this.$listeners,
                    input() {},
                    change() {
                        vm.$emit('input', vm.localValue);
                    },
                    blur(event) {
                        vm.$emit('blur', event);
                    },
                };
            },
        },

        watch: {
            value(vl) {
                this.localValue = !!vl;
            },
        },

        created() {},

        methods: {},
    };
</script>
